export default __webpack_public_path__ + "static/media/Bree.1266119d.png";